var cannotLoadAjax = "Can not process your request";
var defaultKeyword = "Enter search term(s)";
var innovaApiUrl = $("#InnovaApiUrl").val();
var innovaApiKey = $("#InnovaKey").val();

$(document).ready(function () {
  $('#keyword').keydown(function (event) {
    if (event.keyCode == 13) {
      searchVideos(1);
    }

  });

  searchVideos(1);

});

pageClick = function (pageclickednumber) {
  searchVideos(pageclickednumber);
}

function searchVideos(page) {
  var keyword = $("#keyword").val();
  if (keyword == defaultKeyword) {
    keyword = "";
  }

  $('#ModalContentAjax').modal("show");
  var totalPage = 0;
  var requestData = 'keyword=' + keyword + '&selectedPage=' + page;
  xhr = $.ajax({
    url: innovaApiUrl + '/supports/search-videos',
    cache: false,
    crossOrigin: true,
    type: 'post',
    data: requestData,
    beforeSend: function (xhr) {
      xhr.setRequestHeader('inn-api-auth-ticket', innovaApiKey);
    },
    error: function () {
      $('#ModalContentAjax').modal("hide");
      alert(cannotLoadAjax);
    },
    success: function (result) {      
      if(result.message.success){
        $('#searchVideosResult').html(result.articleResult);
        var totalPage = result.pageCount;        
        var itemsCount = result.recordCount;
        var itemsOnPage = result.pageSize;
        
        var pagination = new Pagination({
          container: $("#pagination"),
          pageClickCallback: pageClick,
          maxVisibleElements: 5
        });
        pagination.make(itemsCount, itemsOnPage, page);

        var videoPopper = new VideoPopper({
          classContainer: "viewVideo"          
        });
        videoPopper.AllfilmVideoPopper();
        
        $('#ModalContentAjax').modal("hide");
      }else{      	 
         $('#ModalContentAjax').modal("hide");
         alert(cannotLoadAjax);
      }

    }
  });

}
